import { ChainId } from '@pancakeswap/sdk'
import addresses from 'config/constants/contracts'
import tokens from 'config/constants/tokens'
import { Address } from 'config/constants/types'



export const getAddress = (address: Address): string => {
  const chainId = process.env.REACT_APP_CHAIN_ID
  return address[chainId] ? address[chainId] : address[ChainId.MAINNET]
}

export const getCakeAddress = () => {
  return getAddress(tokens.cake.address)
}

export const getLiveTradeAddress = () => {
  return getAddress(tokens.livetrade.address)
}

export const getKscAddress = () => {
  return getAddress(tokens.kshark.address)
}
export const getBksAddress = () => {
  return getAddress(tokens.babykshark.address)
}
export const getMasterChefAddress = () => {
  return getAddress(addresses.masterChef)
}
export const getMulticallAddress = () => {
  return getAddress(addresses.multiCall)
}
export const getWbnbAddress = () => {
  return getAddress(tokens.wbnb.address)
}
export const getLotteryV2Address = () => {
  return getAddress(addresses.lotteryV2)
}
export const getPancakeProfileAddress = () => {
  return getAddress(addresses.pancakeProfile)
}
export const getPancakeRabbitsAddress = () => {
  return getAddress(addresses.pancakeRabbits)
}
export const getBunnyFactoryAddress = () => {
  return getAddress(addresses.bunnyFactory)
}
export const getClaimRefundAddress = () => {
  return getAddress(addresses.claimRefund)
}
export const getPointCenterIfoAddress = () => {
  return getAddress(addresses.pointCenterIfo)
}
export const getBunnySpecialAddress = () => {
  return getAddress(addresses.bunnySpecial)
}
export const getTradingCompetitionAddress = () => {
  return getAddress(addresses.tradingCompetition)
}
export const getEasterNftAddress = () => {
  return getAddress(addresses.easterNft)
}
export const getCakeVaultAddress = () => {
  return getAddress(addresses.cakeVault)
}
export const getPredictionsAddress = () => {
  return getAddress(addresses.predictions)
}
export const getChainlinkOracleAddress = () => {
  return getAddress(addresses.chainlinkOracle)
}
export const getBunnySpecialCakeVaultAddress = () => {
  return getAddress(addresses.bunnySpecialCakeVault)
}
export const getBunnySpecialPredictionAddress = () => {
  return getAddress(addresses.bunnySpecialPrediction)
}
export const getBunnySpecialLotteryAddress = () => {
  return getAddress(addresses.bunnySpecialLottery)
}

export const getFarmAuctionAddress = () => {
  return getAddress(addresses.farmAuction)
}

export const getAirdropAddress = () => {
  return getAddress(addresses.airdrop)
}

export const getMemberOfKSharkAddress = () => {
  return getAddress(addresses.memberOfShark)
}

export const getKSharkAddress = () => {
  return getAddress(tokens.kshark.address)
}

export const getBabyKSharkAddress = () => {
  return getAddress(tokens.babykshark.address)
}

export const getReferralsAddress = () => {
  return getAddress(addresses.referrals)
}
export const getMigrationAddress = () => {
  return getAddress(addresses.ltdMigration)
}
export const airdropAddress = () => {
  return getAddress(addresses.ltdAirdop)
}


